import { pointerWithin, rectIntersection } from '@dnd-kit/core';

var pointerWithinAndKeyboardFallback = function pointerWithinAndKeyboardFallback(fallbackAlgorithm) {
  return function (args) {
    var pointerCollisions = pointerWithin(args);
    if (pointerCollisions.length > 0) {
      return pointerCollisions;
    }
    return (fallbackAlgorithm || rectIntersection)(args);
  };
};

export { pointerWithinAndKeyboardFallback };
